import { Nullable } from '@clearverify/types';

export enum VerifyAutomaticModalFormFields {
  legalBusinessName = 'legalBusinessName',
  FEIN = 'FEIN',
  address = 'address',
  contactPhone = 'contactPhone',
  websiteURL = 'websiteURL',
  firstName = 'firstName',
  lastName = 'lastName',
  phoneNumber = 'phoneNumber',
  email = 'email',
}
export enum VerifyAutomaticModalFormAddressFields {
  address = 'address',
  street = 'street',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
  county = 'county',
}

type VerifyAutomaticFormAddressValues = {
  [VerifyAutomaticModalFormAddressFields.street]: Nullable<string>;
  [VerifyAutomaticModalFormAddressFields.city]: Nullable<string>;
  [VerifyAutomaticModalFormAddressFields.state]: Nullable<string>;
  [VerifyAutomaticModalFormAddressFields.zipCode]: Nullable<string>;
  [VerifyAutomaticModalFormAddressFields.county]: Nullable<string>;
};

export type VerifyAutomaticModalFormValues = {
  [VerifyAutomaticModalFormFields.legalBusinessName]: Nullable<string>;
  [VerifyAutomaticModalFormFields.FEIN]: Nullable<string>;
  [VerifyAutomaticModalFormFields.address]: Nullable<VerifyAutomaticFormAddressValues>;
  [VerifyAutomaticModalFormFields.contactPhone]: Nullable<string>;
  [VerifyAutomaticModalFormFields.websiteURL]: Nullable<string>;
  [VerifyAutomaticModalFormFields.firstName]: Nullable<string>;
  [VerifyAutomaticModalFormFields.lastName]: Nullable<string>;
  [VerifyAutomaticModalFormFields.phoneNumber]: Nullable<string>;
  [VerifyAutomaticModalFormFields.email]: Nullable<string>;
};
